export const removeUndefinedKeys = <TObject>(obj: TObject): TObject =>
  Object.fromEntries(
    Object.entries(obj as { [s: string]: unknown }).filter(
      ([, value]) => value !== undefined
    )
  ) as TObject;
